import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Styles } from '../styles/courseTag.js';

class CourseTag extends Component {
    render() {
        return (
            <Styles>
                {/* Course Tag */}
                <div className="course-tag">
                    <h5>Course Tag</h5>
                    <div className="tag-box">
                        <Link to={"/"}>Engineering</Link>
                        <Link to={"/"}>Management</Link>
                        <Link to={"/"}>Commerce</Link>
                        <Link to={"/"}>Science</Link>
                        <Link to={"/"}>Medical</Link>
                        <Link to={"/"}>Computer Applications</Link>
                        <Link to={"/"}>Arts & Humanities</Link>
                    </div>
                </div>
            </Styles>
        )
    }
}

export default CourseTag
